<!-- add markup to be found by the EditPageComponent -->
<div class="error-markup" *ngIf="validationFormControl && validationFormControl.errors" style="display: none"></div>
<!---->
<div class="message" *ngIf="validationFormControl && validationFormControl.errors && (validationFormControl.dirty || validationFormControl.touched) && validationFormControl.errors['validationMessages']">
    <div class="message-label">
        <div class="message-label-title" *ngFor="let validationMessage of validationFormControl.errors.validationMessages">
            {{validationMessage.messageKey | translate:validationMessage.messageParams}}
        </div>
    </div>
</div>
